export default "__VITE_PUBLIC_ASSET__422a2373__"